import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  body: {
    display: "flex",
    flexDirection:"column",
    paddingTop: "71px",
    paddingBottom:"120px",
    paddingRight:"20px",
    paddingLeft:"20px",
  },
  headertitleText:{
    fontSize:"23px !important",
    color:"#ffffff",
    fontWeight:"bold",
  },
  titleText:{
    fontSize:"18px !important",
    color:"#ffffff",
    fontWeight:"bold",
  },
  strongDescriptionText:{
    fontSize:"14px !important",
    color:"#ffffff",
  },
  weakDescriptionText:{
    fontSize:"14px !important",
    color:"#c1c1c1",
  },
  howSection : {
    display:"flex",
    gap:"20px",
    paddingBottom:"14px",
  },
  howTitleText : {
    fontSize:"14px !importatn",
    color:"#ffffff",
    fontWeight:"bold",
  },
  howDesText : {
    fontSize:"14px !importatn",
    color:"#c1c1c1",
  },
  howRightSection:{
    display:"flex",
    flexDirection:"column",
    gap:"5px",
  },
  howLeftSection:{
    width:"20px",
  },
}));

export default useStyles;
